import api from './api';

export interface Settings {
  [key: string]: string | undefined;
  whatsapp_number?: string;
  desktop_logo?: string;
  mobile_logo?: string;
  header_primary_color?: string;
  header_secondary_color?: string;
}

export const settingsService = {
  getSettings: async (): Promise<Settings> => {
    const response = await api.get('/settings');
    return response.data || {};
  },
  
  updateSettings: async (settings: Settings) => {
    const response = await api.put('/settings', settings);
    return response.data;
  }
};